import { LoadingButton } from "@mui/lab";
import { Card, CardActions, CardContent, CardHeader, Divider, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useUpdateShippingTypeMutation } from "src/_api/merchantApi";

export default function ShippingCompanyType({ merchant, profileRefetch, id }) {
    const { t } = useTranslation();

    const [updateShippingType, { isLoading, error, isSuccess, reset }] = useUpdateShippingTypeMutation()

    const [merchantDetails, setMerchantDetails] = useState({ shippingType: "FIRST_AND_LAST_MILE" })

    useEffect(() => {
        if (!!merchant) {
            setMerchantDetails(prev => ({ shippingType: merchant.shippingType }))
        }
    }, [merchant])

    const changeHandler = ({ target: { name, value } }) => {
        setMerchantDetails(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const updateShippingTypeHandler = async () => {
        reset()
        let payload = { shippingType: merchantDetails?.shippingType }
        await updateShippingType({ ...payload, id })
        profileRefetch()
    }

    return (
        <Card sx={{ height: "100%", display: 'flex', flexDirection: 'column' }}>
            <CardHeader title={t("Shipping company type")} />
            <Divider />
            <CardContent sx={{ flex: 1 }}  >
                <FormControl>
                    <RadioGroup
                        aria-labelledby="shipping-type-group"
                        name="shippingType"
                        value={merchantDetails?.shippingType || "FIRST_AND_LAST_MILE"}
                        onChange={changeHandler}
                    >
                        <FormControlLabel value="FIRST_MILE" control={<Radio />} label={t("First mile")} />
                        <FormControlLabel value="LAST_MILE" control={<Radio />} label={t("Last mile")} />
                        <FormControlLabel value="FIRST_AND_LAST_MILE" control={<Radio />} label={t("First and last mile")} />
                    </RadioGroup>
                </FormControl>
            </CardContent>
            <Divider />
            <CardActions sx={{ display: "flex", justifyContent: "space-between", flexDirection: 'row-reverse' }}>
                <LoadingButton sx={{ textTransform: 'none' }} variant="contained" loading={isLoading} onClick={updateShippingTypeHandler}>{t("Confirm")}</LoadingButton>
                {error && <Typography color='text.danger'>{t(error)}</Typography>}
                {isSuccess && <Typography color='success.main'>{t("Done successfully")}</Typography>}
            </CardActions>
        </Card>
    )
}